<ama-ng-app-store-offices-list
  [headerTemplate]="header"
  [itemTemplate]="office"
  [offices]="(configurationService.officesInActiveParent$ | async)?? []"
  class="d-flex flex-column flex-grow-1"
  >
  <ng-template #header let-offices>
    <input
      id="select-all-checkbox"
      class="form-check-input ps-2"
      type="checkbox"
      value=""
                [disabled]="!canCreateConfiguration || (
                !areConfigurationOverridesEnabled && (configurationService.areNoOfficesDeployed$ | async)) ||
                (configurationService.isManagementAllowedForSelectedEntity$ | async) === false"
      [ngbTooltip]="configurationService.allDisabledReason$ | async"
      [indeterminate]="configurationService.areSomeOfficesSelected$ | async"
      [checked]="configurationService.areAllOfficesSelected$ | async"
      (change)="toggleSelectAll($event.target.checked, offices)"
      />
      <label for="select-all-checkbox" class="form-check-label">
        All offices
      </label>
    </ng-template>
    <ng-template #office let-office>
      <input
        class="col-1 form-check-input my-auto ms-2 me-2"
        type="checkbox"
        value=""
        aria-label="Select"
        [id]="'checkbox-' + office.actor.actorName"
                [disabled]="(office.isParentDeployed && !areConfigurationOverridesEnabled) || !canCreateConfiguration ||
                (deploymentService.isDeploymentAllowedForGivenEntity$(office) | async) === false"
        [ngbTooltip]="(deploymentService.deploymentDisabledReason$(office) | async)"
        [checked]="office.isSelected"
        (change)="onSelectOfficeDeploymentCheckboxChange(office)"
        />
        <label [for]="'checkbox-' + office.actor.actorName"
          class="form-check-label overflow-hidden office-label"
          [id]="'label-' + office.actor.actorName">
          <span>{{ office.actor.actorName }}</span>
        </label>

        @if (areConfigurationOverridesEnabled && office.configurationOverrides?.length > 0) {
          <span aria-hidden="true"
            class="col text-start flex-grow-1 me-1 ms-2 text-truncate text-gray"
            [ngbTooltip]="office.configurationOverrides | configurationsTooltip"
            placement="top auto" container="body"
            [id]="'configuration-override-name-' + office.actor.actorName"
            >
            {{ office.configurationOverrides  | configurationNames }}
          </span>
          <span [id]="'configuration-override-badge-' + office.actor.actorName"
          class="badge rounded-pill bg-neutral-soft me-2">Override</span>
        }

        @if (office.configurations?.length > 0) {
          <span
            aria-hidden="true"
            class="col text-start flex-grow-1 me-1 ms-2 text-truncate text-gray"
            [ngbTooltip]="office.configurations | configurationsTooltip"
            placement="top auto" container="body"
            [id]="'configuration-name-' + office.actor.actorName"
            >
            {{ office.configurations  | configurationNames }}
          </span>
        }
      </ng-template>
    </ama-ng-app-store-offices-list>

